import Vue from 'vue'
// import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'

import VueAwesomeSwiper from '@/plugins/ssr-nuxt-swiper'

Vue.use(VueAwesomeSwiper)